import * as React from 'react'
import {useAppContextState} from "app/@hooks";
import {createContext} from "use-context-selector";


const Context = createContext({})

const initialState = {
	calendarData: {}, eventsData: [], sliderColor: [-10,3], showModalDay: false,
	infoDay: {}, isLoading: false, isOpenEventPopover: false, priceByNight: false,
	dates: [], monthAlerts: {}, isOpenAlertsDrawer: false, monthYear: null
}

export function CompetitionAnalyzerCalendarProvider({children}) {
	const { state, updateState } = useAppContextState(initialState)

	return <Context.Provider value={{ state, updateState }}>
		{children}
	</Context.Provider>
}

export default Context